import { Button, createStyles, Grid, GridSize, makeStyles, Theme } from "@material-ui/core";
import useText from "constants/text";
import { IProductPick, ItemAtPoint } from "contexts/RequestQuoteContext";
import { Product, Weight } from "generated/graphql";
import { CloseIcon } from "icons";
import React, { useMemo, useState } from "react";
import Autocomplete from "ui/Autocomplete";
import { TextField } from "ui/TextField";
import { isFieldWithValue, ProductSizes } from "../shared/utils";
import { DeleteIconWrapper, useFormStyles } from "./style";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonStyled: {
      width: "initial",
      [theme.breakpoints.down("xs")]: {
        height: "4vh",
        minWidth: "auto",
        right: "25px"
      }
    },
    content:{paddingBottom: "2%"},
    list: {paddingTop: "2%"}
  })
);
interface IDescribe {
  onValidate: (newProduct: Product, counter: number, deleted: boolean) => void;
  articlesTopick: ItemAtPoint[];
  catalogProducts: IProductPick[];
  onValidateFromList: (products: ItemAtPoint[]) => void;
  newProdList: IProductPick[];
  setNewProdList: React.Dispatch<React.SetStateAction<IProductPick[]>>;
  onSubmit: boolean;
  close: () => void;
  errors: boolean[];
  setErrors: React.Dispatch<React.SetStateAction<boolean[]>>;
  hasErrors: () => boolean;
}

export default function DescribeProduct({
  onValidate,
  articlesTopick,
  catalogProducts,
  onValidateFromList,
  newProdList,
  setNewProdList,
  onSubmit,
  close,
  errors,
  setErrors,
  hasErrors,
}: IDescribe) {
  const emptyProduct: IProductPick = {
    description: null,
    value: null,
    weight: null,
    _id: null,
  };
  const styles = useStyles();
  const classes = useFormStyles();
  const { text } = useText();

  const handleAdd = () => {
    if (newProdList?.length === 0) {
      setNewProdList([
        {
          ...emptyProduct,
        },
      ]);
      setErrors([false]);
    } else {
      const error = hasErrors();
      if (!error) {
        setNewProdList([
          ...newProdList,
          {
            ...emptyProduct,
          },
        ]);
        setErrors([...errors, false]);
      }
    }
  }

  const handleChange = {
    description: (event: any, index: number) => {
      const products = [...newProdList];
      const product = { ...products[index] };
      product.description = event.target.value;
      products[index] = product;
      setNewProdList(products);
    },
    quantity: (event: any, index: number) => {
      const products = [...newProdList];
      const product = { ...products[index] };
      product.volume = Number(event.target.value as string);
      products[index] = product;
      setNewProdList(products);
    },
    value: (event: any, index: number) => {
      const products = [...newProdList];
      const product = { ...products[index] };
      product.value = Number(event.target.value as string);
      products[index] = product;
      setNewProdList(products);
    },
    weight: (event: any, value: any, index: number) => {
      const products = [...newProdList];
      const product = { ...products[index] };
      product.weight = value as Weight;
      products[index] = product;
      setNewProdList(products);
    },
  };

  const onRemoveProduct = (index: number) => {
    setNewProdList((prevProducts) => prevProducts.filter((prod, indx) => indx !== index));
  };

  let size: GridSize = 6;

  const xSize = useMemo(() => {
    if (newProdList?.length === 2) {
      size = 5;
    }
    return size;
  }, [newProdList]);

  const renderForm = (newProduct: IProductPick, index: number) => (
    <Grid container direction="row" alignContent="space-between" spacing={2} className={styles.content}>
    <Grid item   xs={xSize}>
    <TextField
      variant="outlined"
      label="Description"
      name="description"
      type="string"
      fullWidth
      value={newProduct?.description || ""}
      onChange={(e) => handleChange.description(e, index)}
      helperText={errors[index] && !isFieldWithValue(newProduct?.description) && text.all.this_field_is_required}
      error={errors[index] && !isFieldWithValue(newProduct?.description)}
    />
    </Grid>
    <Grid item xs={2}>
    <TextField
      variant="outlined"
      label="Value"
      name="value"
      type="number"
      inputProps={{
        min: 0,
      }}
      fullWidth
      value={newProduct?.value || ""}
      onChange={(e) => handleChange.value(e, index)}
      helperText={errors[index] && !newProduct?.value && text.all.this_field_is_required}
      error={errors[index] && !newProduct?.value}
    />
    </Grid>
    <Grid item xs={2}>
    <TextField
      variant="outlined"
      label="Quantity"
      name="quantity"
      type="number"
      inputProps={{
        min: 0,
      }}
      fullWidth
      value={newProduct?.volume || ""}
      onChange={(e) => handleChange.quantity(e, index)}
      helperText={errors[index] && !newProduct?.volume && text.all.this_field_is_required}
      error={errors[index] && !newProduct?.volume}
    />
    </Grid>
    <Grid item xs={2}>
    <Autocomplete
      label={text.all.size}
      options={ProductSizes}
      getOptionLabel={(option: any) => option?.replace(/_/g, " ")}
      getOptionSelected={(option: any, value: any) => option === value}
      fullWidth
      onChange={(event: any, value: any) => handleChange.weight(event, value, index)}
      value={newProduct?.weight}
      error={errors[index] && !newProduct?.weight}
      helperText={errors[index] && !newProduct?.weight && text.catalog.error_size}
    />
    </Grid>

    <Grid item xs={1} style={{display: `${newProdList?.length === 2? "flex": "none"}`}}>
    <DeleteIconWrapper onClick={() => onRemoveProduct(index)}>
      <CloseIcon />
    </DeleteIconWrapper>
  </Grid>

  </Grid> 
  );



  return (
    <Grid className={styles.list}>
      {newProdList.map((product, index) => renderForm(product, index))}
      <Grid container direction="row" xs={12}> 
        <Button variant="outlined" color="primary" onClick={handleAdd} className={styles.buttonStyled}>
          + 
        </Button>
        <div className={classes.textStyle}>
          {text.all.add_product}
          </div>
        </Grid>
    </Grid>
  );
}
